import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../../../backend/firebaseConfig";

export const getBankHolidayDocId = (region, year) => {
  return `${region}_${year}`;
};

export const fetchGovUkBankHolidays = async ({
  region = "england-and-wales",
  year,
}) => {
  const response = await fetch("https://www.gov.uk/bank-holidays.json");

  if (!response.ok) {
    throw new Error("Failed to fetch GOV.UK bank holidays.");
  }

  const data = await response.json();
  const events = data?.[region]?.events || [];

  return events
    .filter((event) => String(event.date).startsWith(String(year)))
    .map((event) => ({
      date: event.date,
      title: event.title,
    }));
};

export const getCachedBankHolidays = async ({
  region = "england-and-wales",
  year,
}) => {
  const docId = getBankHolidayDocId(region, year);

  const bankHolidayRef = doc(
    db,
    "HolidayConfig",
    "BankHolidays",
    "Items",
    docId,
  );

  const snapshot = await getDoc(bankHolidayRef);

  if (snapshot.exists()) {
    return snapshot.data()?.dates || [];
  }

  const dates = await fetchGovUkBankHolidays({
    region,
    year,
  });

  await setDoc(bankHolidayRef, {
    year,
    region,
    source: "gov.uk",
    dates,
    updatedAt: serverTimestamp(),
  });

  return dates;
};
